import {looksLikeGenerationRequest} from './generationIntent';
/** Entry surface/context is not execution permission. Both composer and API use
 * the existing positive action-intent contract, including explicit continuations. */
export function conversationOnlySubmission(message:string,history?:Array<{role:string;content?:unknown}>,hasSelectedImage=false):boolean {
  return !looksLikeGenerationRequest(message,history,hasSelectedImage);
}
